// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFormats.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var REPORT_FORMAT = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var trackable = require('share/tracking/Izenda.Trackable');
  var { isNil } = require('lodash/fp');

  var Format = function(data) {
    var props = {
      name: data.name || '',
      items: data.items || [],
      visible: data.visible || false
    };

    m.extendObservable(trackable(this), props);
  };

  Format.prototype.setVisible = m.action(function(visible, markDirty) {
    var shouldDirty = isNil(markDirty) || markDirty;
    this.visible = visible;
    shouldDirty && this.markDirty();
  });

  function ReportDesignerFormats() {
    var props = {
      name: REPORT_FORMAT.TITLE,
      headerFooter: new Format(REPORT_FORMAT.HEADER_FOOTER),
      titleDescription: new Format(REPORT_FORMAT.TITLE_DESCRIPTION)
    };
    m.extendObservable(trackable(this), props);
  }

  ReportDesignerFormats.prototype.readFromReport = m.action(function(report) {
    ensure(report, 'Report cannot be null or undefined');

    var header = report.header || {};
    var title = report.titleDescription || {};
    this.headerFooter.setVisible(header.visible, false);
    this.titleDescription.setVisible(title.visible, false);
  });

  /**
   * Set visible for Header Footer
   * @param {boolean} value
   */
  ReportDesignerFormats.prototype.setHeaderFooterVisible = function(value) {
    this.headerFooter.setVisible(value);
  };

  /**
   * Get Header Footer visible
   */
  ReportDesignerFormats.prototype.getHeaderFooterVisible = function() {
    return this.headerFooter.visible;
  };

  /**
   * Set visible for Title Description
   * @param {boolean} value
   */
  ReportDesignerFormats.prototype.setTitleDescriptionVisible = function(value) {
    this.titleDescription.setVisible(value);
  };

  /**
   * Get Title Description visible
   */
  ReportDesignerFormats.prototype.getTitleDescriptionVisible = function() {
    return this.titleDescription.visible;
  };

  /**
   * Get Dirty Status
   * @returns {boolean}
   */
  ReportDesignerFormats.prototype.checkDirty = function() {
    return this.headerFooter.isDirty || this.titleDescription.isDirty;
  };

   /**
   * Clean Dirty Status
   */
  ReportDesignerFormats.prototype.cleanDirty = function() {
    this.headerFooter.resetDirty();
    this.titleDescription.resetDirty();
  };

  module.exports = ReportDesignerFormats;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportDesignerFormats.js